import React from 'react'

export const AgronomyDash = (props) => {
    return (
        <div>
            <div>
                <a href="/">
                    <i className='bi bi-house-door'></i>
                </a>
                <h3 className='bi bi-home card_10'>Create Users</h3>
            </div>



            <div className="">
                <div className="row">
                    <div className="col-md-3">
                        <div className="card card-1">
                            <div className="row">
                                <div className="col-7">
                                    <h5><i className='bi bi-people-fill icon-green'></i> Growers</h5>
                                </div>
                            </div>
                            <div className="d-flex align-items-center">
                                <div className="row">
                                    <div className="col">
                                        <p className="mb-0 text-secondary">Contracted</p>
                                        <h6 className="my-1 text-info"><b>1200</b></h6>
                                    </div>
                                </div>
                                <div className="widgets-icons-2 rounded-circle bg-gradient-scooter text-white ms-auto">
                                    <p className="mb-0 text-secondary">Hectares</p>
                                    <h6 className="my-1 text-info"><b>1,800</b></h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card card-2">
                            <h5><i className="bi bi-person-vcard"></i> Field Officers</h5>
                            <div className="d-flex align-items-center row">
                                <div className="col">
                                    <p className="mb-0 text-secondary">A-Managers</p>
                                    <h6 className="my-1 text-info"><b>10</b></h6>
                                </div>
                                <div
                                    className="widgets-icons-2 rounded-circle bg-gradient-scooter text-white ms-auto col">
                                    <p className="mb-0 text-secondary">L-Technicians</p>
                                    <h6 className="my-1 text-info"><b>50</b></h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card card-3">
                            <h5><i className="bi bi-map"></i> Regions</h5>
                            <div className="d-flex align-items-center row">
                                <div className="col">
                                    <p className="mb-0 text-secondary">Provinces</p>
                                    <h6 className="my-1 text-info"><b>5</b></h6>
                                </div>
                                <div
                                    className="widgets-icons-2 rounded-circle bg-gradient-scooter text-white ms-auto col">
                                    <p className="mb-0 text-secondary">Districts</p>
                                    <h6 className="my-1 text-info"><b>30</b></h6>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card card-4">
                            <h5><i className="bi bi-geo-alt-fill"></i> Locations</h5>
                            <div className="d-flex align-items-center row">
                                <div className="col">
                                    <p className="mb-0 text-secondary">Geo-Locations</p>
                                    <h6 className="my-1 text-info"><b>2500</b></h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <br/>
            <br/>

            <div className='card_2'>

                <h5><b>Field Officers </b> <i className="bi bi-person-vcard-fill"></i></h5>

                <div className='table table-responsive' data-bs-spy="scroll" style={{ maxHeight: "300px",
                    overflowY: "auto" }}>

                    <table className='table table-striped'>
                        <thead style={{ position: "sticky",
                            top: "0" }} className='card_10'>
                        <th>Id</th>
                        <th>F.Officer</th>
                        <th>Region</th>
                        <th>District</th>
                        <th># of Growers</th>
                        <th>Hectares</th>
                        <th>Area Manager</th>
                        </thead><br />
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>Tafadzwa Maduuro</td>
                                <td>Manicaland</td>
                                <td>Makoni</td>
                                <td>145</td>
                                <td>180</td>
                                <td>Bright Kaponda</td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>Tafadzwa Maduuro</td>
                                <td>Manicaland</td>
                                <td>Makoni</td>
                                <td>145</td>
                                <td>180</td>
                                <td>Bright Kaponda</td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>Tafadzwa Maduuro</td>
                                <td>Manicaland</td>
                                <td>Makoni</td>
                                <td>145</td>
                                <td>180</td>
                                <td>Bright Kaponda</td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>Tafadzwa Maduuro</td>
                                <td>Manicaland</td>
                                <td>Makoni</td>
                                <td>145</td>
                                <td>180</td>
                                <td>Bright Kaponda</td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>Tafadzwa Maduuro</td>
                                <td>Manicaland</td>
                                <td>Makoni</td>
                                <td>145</td>
                                <td>180</td>
                                <td>Bright Kaponda</td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>Tafadzwa Maduuro</td>
                                <td>Manicaland</td>
                                <td>Makoni</td>
                                <td>145</td>
                                <td>180</td>
                                <td>Bright Kaponda</td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>Tafadzwa Maduuro</td>
                                <td>Manicaland</td>
                                <td>Makoni</td>
                                <td>145</td>
                                <td>180</td>
                                <td>Bright Kaponda</td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>Tafadzwa Maduuro</td>
                                <td>Manicaland</td>
                                <td>Makoni</td>
                                <td>145</td>
                                <td>180</td>
                                <td>Bright Kaponda</td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>Tafadzwa Maduuro</td>
                                <td>Manicaland</td>
                                <td>Makoni</td>
                                <td>145</td>
                                <td>180</td>
                                <td>Bright Kaponda</td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>Tafadzwa Maduuro</td>
                                <td>Manicaland</td>
                                <td>Makoni</td>
                                <td>145</td>
                                <td>180</td>
                                <td>Bright Kaponda</td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>Tafadzwa Maduuro</td>
                                <td>Manicaland</td>
                                <td>Makoni</td>
                                <td>145</td>
                                <td>180</td>
                                <td>Bright Kaponda</td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>Tafadzwa Maduuro</td>
                                <td>Manicaland</td>
                                <td>Makoni</td>
                                <td>145</td>
                                <td>180</td>
                                <td>Bright Kaponda</td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>Tafadzwa Maduuro</td>
                                <td>Manicaland</td>
                                <td>Makoni</td>
                                <td>145</td>
                                <td>180</td>
                                <td>Bright Kaponda</td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>Tafadzwa Maduuro</td>
                                <td>Manicaland</td>
                                <td>Makoni</td>
                                <td>145</td>
                                <td>180</td>
                                <td>Bright Kaponda</td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>Tafadzwa Maduuro</td>
                                <td>Manicaland</td>
                                <td>Makoni</td>
                                <td>145</td>
                                <td>180</td>
                                <td>Bright Kaponda</td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>Tafadzwa Maduuro</td>
                                <td>Manicaland</td>
                                <td>Makoni</td>
                                <td>145</td>
                                <td>180</td>
                                <td>Bright Kaponda</td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>Tafadzwa Maduuro</td>
                                <td>Manicaland</td>
                                <td>Makoni</td>
                                <td>145</td>
                                <td>180</td>
                                <td>Bright Kaponda</td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>Tafadzwa Maduuro</td>
                                <td>Manicaland</td>
                                <td>Makoni</td>
                                <td>145</td>
                                <td>180</td>
                                <td>Bright Kaponda</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>


        </div>
    )
}


